import { render, staticRenderFns } from "./TermEditMultiRelationship.vue?vue&type=template&id=2e4fc63c&scoped=true"
import script from "./TermEditMultiRelationship.vue?vue&type=script&lang=js"
export * from "./TermEditMultiRelationship.vue?vue&type=script&lang=js"
import style0 from "./TermEditMultiRelationship.vue?vue&type=style&index=0&id=2e4fc63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4fc63c",
  null
  
)

export default component.exports